import * as React from 'react'
import CommonDatePicker from '../datepicker'
import EndDatePicker from '../datepicker/endDatePicker'
import { makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { getCompaniesAction } from '../../containers/login/action';
import { CommonTableTwo } from '../table';
import CommonFormDropDown from '../formdropdown';
import CommonButton from '../button';
import { sendCustomCompanyReportsAction } from '../../containers/dashboard/action';
import { getStartEndDate } from '../../utils';
import DragDatePreviewer from '../datepicker/dragDatePickerPreviewer';

let companyOptions = []

const useStyles = makeStyles(() => ({
  root: {
    marginTop: "15px"
  },
  dateGrp: {

  }
}))

export default function CustomNotificationReports() {
  const classes = useStyles();
  const [selectedCompanies, setSelectedCompanies] = React.useState("")

  const [start_date, end_date] = getStartEndDate()
  const [startDate, setStartDate] = React.useState(start_date.toISOString())
  const [endDate, setEndDate] = React.useState(end_date.toISOString())

  const dispatch = useDispatch()
  const loginReducer = useSelector(state => state.loginReducer)

  const getCompaniesActionMethod = React.useCallback(() => {
    return dispatch(getCompaniesAction())
  }, [dispatch])
  const sendCustomCompanyReportsActionMethod = React.useCallback(
    (data) => (
      dispatch(sendCustomCompanyReportsAction(data))
    ), [dispatch]
  )

  React.useEffect(() => {
    getCompaniesActionMethod()
  }, [])

  React.useEffect(() => {
    if (loginReducer?.companyOptions?.length) {
      companyOptions = [];
      for (let i = 0; i < loginReducer?.companyOptions.length; i++) {
        const each = loginReducer?.companyOptions[i];
        if (
          companyOptions.findIndex(
            (rec) => rec.value && rec.value === each.id
          ) < 0
        )
          companyOptions.push({ value: each.id, label: each.name });
      }
    }
  }, [getCompaniesActionMethod, dispatch])


  return (
    <div className={classes.root}>
      <CommonFormDropDown
        isMulti={true}
        placeholder={"Select Companies"}
        options={companyOptions}
        value={selectedCompanies}
        onChange={(value) => {
          setSelectedCompanies(value);
        }}
      />
      <CommonTableTwo
        columns={
          [
            {
              Header: "Calendar Picker",
              accessor: "start_datetime",
              Cell: (data, row) => {
                return (<div>
                  <DragDatePreviewer
                    startDateValue={startDate?.split("T")[0]}
                    setStartDateValue={(date) => {
                      const dt = new Date(date)
                      setStartDate(dt.toISOString())
                    }}
                    endDateValue={endDate?.split("T")[0]}
                    setEndDateValue={(date) => {
                      const dt = new Date(date)
                      setEndDate(dt.toISOString())
                    }}
                    absoluteCalendar={false}
                  />
                </div>)
              }
            },

            {
              Header: "Triggers",
              accessor: "trigger_word",
              Cell: (data, row) => {
                return (
                  <CommonButton onClick={
                    (e) => {
                      sendCustomCompanyReportsActionMethod({
                        start_date: startDate,
                        end_date: endDate,
                        companies: selectedCompanies.map((d) => d.value)
                      })
                    }}
                    disabled={selectedCompanies?.length <= 0}
                    text={data} stylevariant="primary"
                  />
                )
              }
            }
          ]
        }
        data={[
          {
            "start_datetime": startDate,
            "end_datetime": endDate,
            "trigger_word": "Send Reports"
          }
        ]}
      />
      <CommonTableTwo
        columns={
          [
            {
              Header: "Start Datetime",
              accessor: "start_datetime",
              Cell: (data, row) => {
                return (<div>
                  <CommonDatePicker
                    setStartDate={
                      (date) => {
                        setStartDate(new Date(date).toISOString());
                      }}
                    startDate={data?.split("T")[0]}
                  /></div>)
              }
            },
            {
              Header: "End Datetime",
              accessor: "end_datetime",
              Cell: (data, row) => {
                return (
                  <div>
                    <EndDatePicker
                      setEndDate={
                        (date) => {
                          setEndDate(new Date(date).toISOString())
                        }
                      }
                      endDate={data?.split("T")[0]}
                    />
                  </div>
                )
              }
            },
            {
              Header: "Triggers",
              accessor: "trigger_word",
              Cell: (data, row) => {
                return (
                  <CommonButton
                    disabled={selectedCompanies?.length <= 0}
                    onClick={
                      (e) => {
                        sendCustomCompanyReportsActionMethod({
                          start_date: startDate,
                          end_date: endDate,
                          companies: selectedCompanies.map((d) => d.value)
                        })
                      }} text={data} stylevariant="primary"
                  />
                )
              }
            }
          ]
        }
        data={[
          {
            "start_datetime": startDate,
            "end_datetime": endDate,
            "trigger_word": "Send Reports"
          }
        ]}
      />
    </div>
  )
}